/**
 * SEO fields for the Ryerson Commitment landing page, `/why-ryerson/ryerson-commitment/`
 * (`src/pages/why-ryerson/ryerson-commitment/index.tsx`). The page's visible copy lives with its
 * components, starting at `src/components/WhyRyerson/RyersonCommitment/Content.tsx`. The `fr` and
 * `es` entries repeat the English text.
 */
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";

/** `MetaHead` content for the landing page, per language. */
export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
	fr: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
	es: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
};

/**
 * Site-search entry for the landing page (`scripts/staticSearch.ts` →
 * `RyersonCommitmentIndexContent`): the SEO fields only, since `content` is empty.
 */
export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [],
};
